import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row } from 'react-bootstrap';
import Tabs from '../../components/Tabs/Tabs';
import {
  addOrRemoveDaysToGivenDate,
  addOrRemoveYearsToGivenDate,
  DateFormats,
  formatDate,
} from '../../utils/utils';
import NewEstimateTab from '../widgets/pensionEstimate/tabs/newEstimateTab';
import SavedEstimatesTab from '../widgets/pensionEstimate/tabs/savedEstimatesTab';

const savedEstimates = [
  {
    scenario1: {
      whenToStopWorking: formatDate(new Date(), DateFormats.US),
      whenToStartPension: formatDate(
        addOrRemoveDaysToGivenDate(new Date(), 14),
        DateFormats.US
      ),
      birthDate: '2020-01-01',
      percentage: '0',
      dateOfSaving: formatDate(new Date(), DateFormats.US),
      name: 'Estimate 1',
      totalAmount: 417,
    },
    scenario2: {
      whenToStopWorking: formatDate(
        addOrRemoveYearsToGivenDate(new Date(), 5),
        DateFormats.US
      ),
      whenToStartPension: formatDate(
        addOrRemoveYearsToGivenDate(
          addOrRemoveDaysToGivenDate(new Date(), 14),
          5
        ),
        DateFormats.US
      ),
      birthDate: '2020-01-01',
      percentage: '0',
      dateOfSaving: formatDate(new Date(), DateFormats.US),
      name: 'Estimate 1',
      totalAmount: 1347,
    },
    link: `${process.env.PUBLIC_URL}/${'PensionEstimate-DemoExample_v1.pdf'}`,
    target: '_blank',
  },
  {
    scenario1: {
      whenToStopWorking: formatDate(
        addOrRemoveYearsToGivenDate(new Date(), 10),
        DateFormats.US
      ),
      whenToStartPension: formatDate(
        addOrRemoveYearsToGivenDate(
          addOrRemoveDaysToGivenDate(new Date(), 14),
          10
        ),
        DateFormats.US
      ),
      birthDate: '2020-01-01',
      percentage: '0',
      dateOfSaving: formatDate(new Date(), DateFormats.US),
      name: 'Estimate 2',
      totalAmount: 2489,
    },
    link: `${process.env.PUBLIC_URL}/${'PensionEstimate-DemoExample_v1.pdf'}`,
    target: '_blank',
  },
  {
    scenario1: {
      whenToStopWorking: formatDate(
        addOrRemoveYearsToGivenDate(new Date(), 15),
        DateFormats.US
      ),
      whenToStartPension: formatDate(
        addOrRemoveYearsToGivenDate(
          addOrRemoveDaysToGivenDate(new Date(), 14),
          15
        ),
        DateFormats.US
      ),
      birthDate: '2020-01-01',
      percentage: '0',
      dateOfSaving: formatDate(new Date(), DateFormats.US),
      name: 'Estimate 3',
      totalAmount: 3565,
    },
    link: `${process.env.PUBLIC_URL}/${'PensionEstimate-DemoExample_v1.pdf'}`,
    target: '_blank',
  },
];

const PensionEstimate = () => {
  const tabsData = [
    {
      name: 'New Estimate',
      content: <NewEstimateTab />,
      leftIcon: <FontAwesomeIcon icon={light('calculator')} />,
      href: '#/pension/estimate/new',
    },
    {
      name: 'Saved Estimates',
      content: <SavedEstimatesTab savedEstimates={savedEstimates} />,
      leftIcon: <FontAwesomeIcon icon={light('rectangle-vertical-history')} />,
      href: '#/pension/estimate/saved',
    },
  ];

  return (
    <Container className="cnd-custom-container px-7 px-lg-0 pt-lg-12 mt-11 mt-lg-12">
      <h4>Pension Estimate</h4>
      <Row>
        <Tabs tabs={tabsData} variant={'horizontal'} />
      </Row>
    </Container>
  );
};

export default PensionEstimate;
